@file:OptIn(InternalResourceApi::class)

package advent_of_code_compose_2025.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/advent_of_code_compose_2025.composeapp.generated.resources/"

internal val Res.drawable.app: DrawableResource by lazy {
      DrawableResource("drawable:app", setOf(
        ResourceItem(setOf(), "${MD}drawable/app.png", -1, -1),
      ))
    }

internal val Res.drawable.arrow_back_48px: DrawableResource by lazy {
      DrawableResource("drawable:arrow_back_48px", setOf(
        ResourceItem(setOf(), "${MD}drawable/arrow_back_48px.xml", -1, -1),
      ))
    }

internal val Res.drawable.button_normal: DrawableResource by lazy {
      DrawableResource("drawable:button_normal", setOf(
        ResourceItem(setOf(), "${MD}drawable/button_normal.png", -1, -1),
      ))
    }

internal val Res.drawable.button_pressed: DrawableResource by lazy {
      DrawableResource("drawable:button_pressed", setOf(
        ResourceItem(setOf(), "${MD}drawable/button_pressed.png", -1, -1),
      ))
    }

internal val Res.drawable.check_mark: DrawableResource by lazy {
      DrawableResource("drawable:check_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/check_mark.xml", -1, -1),
      ))
    }

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.cross_mark: DrawableResource by lazy {
      DrawableResource("drawable:cross_mark", setOf(
        ResourceItem(setOf(), "${MD}drawable/cross_mark.xml", -1, -1),
      ))
    }

internal val Res.drawable.led_off: DrawableResource by lazy {
      DrawableResource("drawable:led_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/led_off.png", -1, -1),
      ))
    }

internal val Res.drawable.led_on: DrawableResource by lazy {
      DrawableResource("drawable:led_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/led_on.png", -1, -1),
      ))
    }

internal val Res.drawable.ready_off: DrawableResource by lazy {
      DrawableResource("drawable:ready_off", setOf(
        ResourceItem(setOf(), "${MD}drawable/ready_off.png", -1, -1),
      ))
    }

internal val Res.drawable.ready_on: DrawableResource by lazy {
      DrawableResource("drawable:ready_on", setOf(
        ResourceItem(setOf(), "${MD}drawable/ready_on.png", -1, -1),
      ))
    }

internal val Res.drawable.right_arrow: DrawableResource by lazy {
      DrawableResource("drawable:right_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/right_arrow.xml", -1, -1),
      ))
    }

internal val Res.drawable.rotate_left: DrawableResource by lazy {
      DrawableResource("drawable:rotate_left", setOf(
        ResourceItem(setOf(), "${MD}drawable/rotate_left.xml", -1, -1),
      ))
    }

internal val Res.drawable.rotate_right: DrawableResource by lazy {
      DrawableResource("drawable:rotate_right", setOf(
        ResourceItem(setOf(), "${MD}drawable/rotate_right.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("app", Res.drawable.app)
  map.put("arrow_back_48px", Res.drawable.arrow_back_48px)
  map.put("button_normal", Res.drawable.button_normal)
  map.put("button_pressed", Res.drawable.button_pressed)
  map.put("check_mark", Res.drawable.check_mark)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("cross_mark", Res.drawable.cross_mark)
  map.put("led_off", Res.drawable.led_off)
  map.put("led_on", Res.drawable.led_on)
  map.put("ready_off", Res.drawable.ready_off)
  map.put("ready_on", Res.drawable.ready_on)
  map.put("right_arrow", Res.drawable.right_arrow)
  map.put("rotate_left", Res.drawable.rotate_left)
  map.put("rotate_right", Res.drawable.rotate_right)
}
